import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { useFetch } from "../Hooks/useFetch";

export const AddressSearchInput = ({ label, placeholder, onChange, type, id_340b, ...props }) => {
  const [addressSearch, setAddressSearch] = useState("");
  const [debouncedSearch] = useDebounce(addressSearch, 300);

  const addressesFetcher = useFetch(
    debouncedSearch
      ? `/api/addresses/search?query=${encodeURIComponent(debouncedSearch)}&type=${type}&id_340b=${id_340b}`
      : undefined
  );

  useEffect(() => {
    if (props.value?.address) {
      setAddressSearch(props.value.address);
    } else if (!props.value) {
      setAddressSearch("");
    }
  }, [props.value, type]);

  const [open, setOpen] = useState(false);
  const options = addressesFetcher.data?.addresses ?? [];

  return (
    <Autocomplete
      {...props}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={options}
      loading={addressesFetcher.loading}
      filterOptions={(x) => x} // Prevents client-side lowercasing crashes
      inputValue={addressSearch}
      onInputChange={(event, newInputValue, reason) => {
        if (reason === "reset" || reason === "blur") return;

        if (typeof newInputValue === "string") {
          setAddressSearch(newInputValue);
        }
      }}
      getOptionLabel={(option) => {
        if (typeof option === "string") return option;
        return option?.address || "";
      }}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        const optionId = option.public_id || option.pharmacy_id;
        const valueId = value.public_id || value.pharmacy_id;
        return optionId === valueId;
      }}
      onChange={(event, newValue) => {
        if (!newValue) {
          setAddressSearch("");
        } else {
          setAddressSearch(newValue.address || "");
        }

        onChange?.(event, newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {addressesFetcher.loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};
